export default __webpack_public_path__ + "static/varios-live-nacional-51ef7c6985d8691b1ed2a1bf8542b1aa.jpg";